/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyContactTypeModel } from '../../models/client-survey-contact-type-model';

export interface GetSurveyContactTypes$Plain$Params {
}

export function getSurveyContactTypes$Plain(http: HttpClient, rootUrl: string, params?: GetSurveyContactTypes$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyContactTypeModel>>> {
  const rb = new RequestBuilder(rootUrl, getSurveyContactTypes$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientSurveyContactTypeModel>>;
    })
  );
}

getSurveyContactTypes$Plain.PATH = '/api/SurveyContactType';
